import { create } from "zustand";

export const BGM_SRC =
  "https://pub-7e9ba51c5ec44a0eaf9613cb1db76861.r2.dev/bgm/geumganggyeong.mp3";

// Module-level singleton: React 컴포넌트 생명주기와 분리되어 라우트 이동 시에도 유지
let _audio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
  if (!_audio) {
    _audio = new Audio(BGM_SRC);
    _audio.loop = true;
    _audio.preload = "none";
  }
  return _audio;
}

type BgmStore = {
  playing: boolean;
  toggle: () => void;
  play: () => void;
  pause: () => void;
};

export const useBgmStore = create<BgmStore>((set, get) => ({
  playing: false,
  toggle: () => {
    const audio = getAudio();
    if (get().playing) {
      audio.pause();
      set({ playing: false });
    } else {
      audio.play().then(() => set({ playing: true })).catch(() => {});
    }
  },
  play: () => {
    getAudio().play().then(() => set({ playing: true })).catch(() => {});
  },
  pause: () => {
    getAudio().pause();
    set({ playing: false });
  },
}));
